"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _episourceColor = _interopRequireDefault(require("../../themes/episourceColor"));
const useStyles = (0, _styles.makeStyles)(theme => (0, _styles.createStyles)({
  nav: {
    'marginTop': '-5px',
    'backgroundColor': _episourceColor["default"].epiAnalystBackgroundLight,
    '& ul': {
      'margin': 0,
      'paddingInlineStart': '32px',
      'width': 'max-content',
      'borderBottom': 'solid 2px rgba(0, 0, 0, 0.12) !important',
      'borderColor': _episourceColor["default"].divider,
      '& li': {
        'display': 'inline-flex',
        'padding': theme.spacing(0, 3),
        'height': '60px',
        'backgroundColor': _episourceColor["default"].epiAnalystBackgroundLight,
        '& a': {
          'display': 'flex',
          'alignItems': 'center',
          'color': _episourceColor["default"].iconDefault,
          'textDecoration': 'none',
          '& span': {
            textTransform: 'none',
            letterSpacing: 'normal'
          }
        }
      },
      '& li.active': {
        'backgroundColor': _episourceColor["default"].textContrast,
        'borderBottom': '5px solid',
        'borderBottomColor': _episourceColor["default"].epiAnalystPrimaryDark,
        '& span': {
          fontWeight: 'bold',
          color: _episourceColor["default"].epiAnalystPrimaryDark
        },
        'paddingTop': '5px'
      },
      '& li.navItem:hover': {
        backgroundColor: _episourceColor["default"].textContrast
      }
    }
  },
  primaryNavName: {
    'paddingLeft': '0 !important',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      color: _episourceColor["default"].iconDefault,
      fontSize: 18,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: 1
    }
  }
}));
const SectionNavBar = _ref => {
  let {
    navItems = [],
    primaryNavName
  } = _ref;
  const classes = useStyles({});
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes.nav
  }, /*#__PURE__*/_react["default"].createElement("ul", null, primaryNavName && /*#__PURE__*/_react["default"].createElement("li", {
    className: classes.primaryNavName
  }, /*#__PURE__*/_react["default"].createElement("span", null, primaryNavName)), navItems.map((item, index) => /*#__PURE__*/_react["default"].createElement("li", {
    key: index,
    className: (0, _clsx["default"])('navItem', {
      active: item.active
    })
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.url && !item.link && /*#__PURE__*/_react["default"].createElement("a", {
    href: item.url
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "button"
  }, item.name)), item.link && item.link)))));
};
var _default = SectionNavBar;
exports["default"] = _default;